module.exports = __webpack_public_path__ + "img/max-file-edit--pdf.940e0662.svg";